import * as React from 'react'

import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import useCreateUpsellRequest, { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

interface Props {
  description: string
  from: 'view_selector' | 'coverage' | 'time_insights'
  children: React.ReactNode
  featureRequested?: Features
}
const UpgradeTooltip = ({ description, from, children, featureRequested }: Props) => {
  const { create } = useCreateUpsellRequest()
  const [isTooltipOpen, toggleTooltip] = useToggle(false)
  const [isThankYouModalOpen, setIsThankYouModalOpen] = React.useState(false)
  const { company } = useCurrentSession()
  const currentSubscription = company.subscription

  const handleUpdatePlan = async () => {
    track(trackingEvents.shiftManagement.requestPlanUpdate, {
      from: from,
    })
    const result = await create({
      moduleRequested: AvailableModules.shift_management,
      featureRequested: featureRequested,
      requestSource: from,
      requestReason: currentSubscription.isLegacy
        ? ValidReasons.MissingFeatureLegacy
        : ValidReasons.MissingFeature,
    })

    if (handleResult(result, () => undefined).success) {
      setIsThankYouModalOpen(true)
    }
  }

  return (
    <>
      <Tooltip.CallToAction
        attachment="top center"
        open={isTooltipOpen}
        toggle={toggleTooltip}
        description={description}
        buttonLabel={i18n.t('shift_management.filters.view_selector.update_plan')}
        onClick={handleUpdatePlan}
      >
        {children}
      </Tooltip.CallToAction>
      {isThankYouModalOpen && (
        <Modal
          illustration="contact-us"
          title={i18n.t('common.thank_you_modal_title')}
          description={i18n.t('common.thank_you_modal_description')}
          onClose={() => {
            toggleTooltip(false)()
            setIsThankYouModalOpen(false)
          }}
          footer={
            <Button
              type="primary"
              onClick={() => {
                toggleTooltip(false)()
                setIsThankYouModalOpen(false)
              }}
            >
              {i18n.t('common.thank_you_modal_close')}
            </Button>
          }
        />
      )}
    </>
  )
}

export default UpgradeTooltip
